/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsticketrefunded2Inputs */

const en_ticketsticketrefunded2 = /** @type {(inputs: Ticketsticketrefunded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunded`)
};

const de_ticketsticketrefunded2 = /** @type {(inputs: Ticketsticketrefunded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstattet`)
};

/**
* | output |
* | --- |
* | "Refunded" |
*
* @param {Ticketsticketrefunded2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsticketrefunded2 = /** @type {((inputs?: Ticketsticketrefunded2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsticketrefunded2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsticketrefunded2(inputs)
	return de_ticketsticketrefunded2(inputs)
});
export { ticketsticketrefunded2 as "ticketsTicketRefunded" }